import { Spin } from '@vivaldis/antd-ui'

export const LoadingState = () => {
  return <Spin />
}
